import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { EntryService } from 'services/entry/entry.service';
import { PasswordValidators } from '../../../validators/password-validators';
import { equalTo } from '@certemy/common';

@Component({
  selector: 'cm-reset-password',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
})
export class ResetPWComponent implements OnInit {
  form: UntypedFormGroup;
  message = '';
  params: any = {};

  constructor(
    private tokenService: TokenService,
    private entryService: EntryService,
    private router: Router,
    private arouter: ActivatedRoute,
  ) {
    const password: UntypedFormControl = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.required,
        Validators.minLength(8),
        PasswordValidators.lowercaseCharacterRule(),
        PasswordValidators.uppercaseCharacterRule(),
        PasswordValidators.oneDigitRule(),
      ]),
    );
    const confirm_password: UntypedFormControl = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, equalTo(password)]),
    );
    this.form = new UntypedFormGroup({
      password,
      confirm_password,
    });
  }

  ngOnInit() {
    this.arouter.params.subscribe(params => {
      this.params = params;
    });
  }

  onSubmit(values: any): void {
    this.message = '';
    if (this.form.valid) {
      this.tokenService
        .updateUserPassword({
          token: this.params.token,
          email: this.params.email,
          password: values.password,
        })
        .subscribe(
          data => {
            if (data.code_name === 'ERROR') {
              this.message = 'Sorry, the link is not valid';
            } else {
              this.entryService.setMessageType({ msg: 'reset_password', email: this.params.email });
              this.router.navigate(['/entry/message']);
            }
          },
          () => {
            this.message = 'Email is incorrect';
          },
        );
    } else {
      if (this.form.controls['password'].errors) {
        if (this.form.controls['password'].errors['required']) {
          this.message = 'Please fill out all fields';
        } else if (this.form.controls['password'].errors['minlength']) {
          this.message = 'Password should be at least 8 symbols';
        } else if (this.form.controls['password'].errors['uppercaseCharacterRule']) {
          this.message = 'Password should including 1 uppercase letter';
        } else if (this.form.controls['password'].errors['lowercaseCharacterRule']) {
          this.message = 'Password should including 1 lowercase letter';
        } else if (this.form.controls['password'].errors['digitCharacterRule']) {
          this.message = 'Password should including 1 digit letter';
        }
      } else if (this.form.controls['confirm_password'].errors) {
        this.message = 'Password does not match the confirm password';
      }
    }
  }
}
